/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface ReportingManager {
  firstName?: string;
  lastName?: string;
  email?: string;
  isDeleted?: boolean;
}

export interface OrgBrief {
  _id?: string;
  name?: string;
}

export interface DepartmentBrief {
  _id?: string;
  name?: string;
}

export interface Supervisor {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: string;
  org?: OrgBrief;
  department?: DepartmentBrief;
  reportingManager?: ReportingManager;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type SupervisorsResponse = {
  success: boolean;
  message?: string;
  count?: number;
  data: Supervisor[];
};

const fetchSupervisors = async (
  orgId: string,
): Promise<SupervisorsResponse> => {
  const { data } = await customAxios.get<SupervisorsResponse>(
    `users/organization/${orgId}/supervisors`,
  );
  return data;
};

export const useGetSupervisors = (orgId?: any | null) =>
  useQuery<SupervisorsResponse, AxiosError>(
    ["supervisors", orgId],
    () => {
      if (!orgId) throw new Error("No organization id provided");
      return fetchSupervisors(orgId);
    },
    {
      enabled: !!orgId,
      onError: (error) =>
        showNotification({
          title: "Error Loading Supervisors",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load supervisors",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    },
  );
